<script>
    import { checkSession_getSelf, apiRequest, communicationError, apiResponseBody } from "../lib/api";
    import { decrypt, encrypt } from "../lib/crypto";
    import { onMount } from "svelte";

    /** @import {User, Session} from "../lib/api" */

    /** @type {User} */
    let user = $state();
    /** @type {Session} */
    let session = $state();


    /** @type {string} */
    let selectedTab = $state("commandApi");

    
    let arbitraryCommand = $state({command: "", body: "", as: ""});
    /** @type {PromiseResponse<>}*/
    let commandResponse = $state();
    /** @type {Object.<string, User>} */
    let users = $state({});


    /**
    @param {Session} session 
    @param {string} command 
    @param {Object} body 
    @returns {Promise<Response>}
    */
    async function debugRequest(session) {
        return fetch("/debug_api", {
            method: "POST",
            headers: [["Content-Type", "application/json"]],
            body: JSON.stringify({
                hash: session.hash,
                body: encrypt(JSON.stringify({
                    command: arbitraryCommand.command,
                    body: JSON.parse(arbitraryCommand.body),
                    as: arbitraryCommand.as
                }), session.key)
            })
        });
    }

    onMount(async ()=>{
        ({session: session, user: user} = await checkSession_getSelf());
        const resp = await apiRequest(session, "users.admin.list", {});
        if (!resp.ok) communicationError("Erreurs lors chargement des utilisateurs");
        users = await apiResponseBody(session, resp);
    });
</script>

<header>
    <a href="/home" id="home-button">
        <img class="icon" src="/www/favicon.png" alt="Letas Icon" />
        <span>{user?.name ?? ""}</span>
    </a>
    <div style="flex-grow: 1;"></div>
    <label class="tab">
        Commande API
        <input type="radio" name="tab" value="commandApi" bind:group={selectedTab} checked/>
    </label>
    <label class="tab">
        Arbre API
        <input type="radio" name="tab" value="apiTree" bind:group={selectedTab}/>
    </label>
</header>

{#if selectedTab == "commandApi"}
    <form class="box gradient" style="width: calc(100% - 2em);" onsubmit={e => {
        e.preventDefault();
        try {
            commandResponse = debugRequest(session);
        } catch (e) {
            alert(e);
        }
    }}>
        <h2>Commande Arbitraire</h2>
        <input
            type="text"
            bind:value={arbitraryCommand.command}
            required
            placeholder="Commande"
        />
        <select bind:value={arbitraryCommand.as} required>
            <option value="" disabled selected>Utilisateur</option>
            {#each Object.entries(users) as [id, u]}
                <option value={id}>{u.name}</option>
            {/each}
        </select>
        <br/>
        <textarea
            bind:value={arbitraryCommand.body}
            placeholder="Data JSON"
            style="width: 100%; min-height: 10lh;"
            required
        ></textarea> <br/>
        <button type="submit">Envoyer</button>
    </form>

    {#if commandResponse}
        <section class="box">
            <h2>Réponse</h2>
            {#await commandResponse then resp}
                <span><b>Status</b> : {resp.status} </span>
                <div class="dark-bg" style="text-align: left; white-space: preserve;">
                    {#if resp.ok}
                        {#await apiResponseBody(session, resp) then body }
                            {JSON.stringify(body, null, 4)}
                        {/await}
                    {:else}
                        {#await resp.text() then body }
                            {body}
                        {/await}
                    {/if}
                </div>
                {:catch err}
                {err}t}
            {/await}
        </section>
    {/if}
{:else if selectedTab == "apiTree"}
    {#await fetch("/debug_api", {
            method: "POST",
            headers: [["Content-Type", "application/json"]],
            body: JSON.stringify({
                hash: session.hash,
                body: encrypt("api_tree", session.key)
            })
        }) then resp}
        {#await resp.json() then body}
            <section
                style="
                    padding: 0.5em;
                    text-align: left;
                    white-space: preserve;
                    font-family: monospace;
                    font-size: 110%;
                "
            >
                {JSON.stringify(JSON.parse(decrypt(body, session.key)), null, "   |")}
            </section>
        {/await}
    {/await}
{/if}


<style>
</style>
